import {getUserRoleService} from '@/services/adminPortalService'
import {GetUserRoleResponse} from '@/types/UserRole'

export async function getUserRoleUseCase(signal?: AbortSignal): Promise<GetUserRoleResponse | undefined> {
  return getUserRoleService(signal)
}
